import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['imageUrl', 'name', 'email', 'admin', 'streamer', 'manager', 'form', 'method'];
  connect() {
  }

  async newUser() {
    this.imageUrlTarget.src = $(this.imageUrlTarget).attr('osrc')
    this.nameTarget.value = "";
    this.emailTarget.value = "";
    this.adminTarget.checked = "";
    this.streamerTarget.checked = "";
    this.managerTarget.checked = "";
    this.formTarget.action = "/admin/users";
    this.methodTarget.value = "post";
    $('#addUserModal .modal-title').addClass('d-none');
    $('#addUserModal .modal-title.add-user').removeClass('d-none');
    $('#addUserModal .modal-body input').attr('disabled', false);
    $('.instructionsLabel').removeClass('d-none');
  }
  
  async fetchUser(event) {
    const id = event.currentTarget.dataset.id;
    const task = event.currentTarget.dataset.task;
    const response = await fetch('/admin/users/' + id + ".json");
    const data = await response.json();
    this.imageUrlTarget.src = data.user.image_url;
    this.nameTarget.value = data.user.name;
    this.emailTarget.value = data.user.email;
    this.adminTarget.checked = data.user.admin;
    this.streamerTarget.checked = data.user.streamer;
    this.managerTarget.checked = data.user.manager;
    this.formTarget.action = '/admin/users/' + id;
    this.methodTarget.value = "patch";
    $('#addUserModal .centered').addClass('d-none'); 
    $('#addUserModal .modal-title').addClass('d-none');
    $('#addUserModal .modal-title.edit-user').removeClass('d-none');
    $('.instructionsLabel').addClass('d-none'); 
    if (task === 'edit') {
      $('#addUserModal .modal-body input').attr('disabled', false);
    }
    else{
      $('#addUserModal .modal-body input').attr('disabled', true);
    }
    //document.getElementById("userPicture").setAttribute('style', `background-image: url('${URL.createObjectURL(event.target.files[0])}');background-position: center;background-size: contain;background-repeat: no-repeat`);
  }
}